var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import { weekDefaultDate } from '../../helper/defaultDate';
import { numMulti } from '../../helper/calucate';
import GLOBAL_VUE from '../../globalVue';
import BusinessGoodsPriceService from '../../api/BusinessGoodsPriceService';
import RequiredMixin from "../../components/renderHeader/RequiredMixin";
import AddGoods from "../licenseManage/components/addGoodsCol2/AddGoods.vue";
import UpdateGoodsPrice from "../licenseManage/components/addGoodsCol2/UpdateGoodsPrice.vue";
import Header from "./components/AddHeader.vue";
import { tidyDataBusinessInfo } from '../../helper/newBusinessGoodsPriceFunc';
import { BigNumber } from "bignumber.js";
var EHandleStatus;
(function (EHandleStatus) {
    EHandleStatus[EHandleStatus["Add"] = 1] = "Add";
    EHandleStatus[EHandleStatus["Edit"] = 2] = "Edit";
    EHandleStatus[EHandleStatus["Copy"] = 3] = "Copy";
})(EHandleStatus || (EHandleStatus = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.PageAuth = {};
        _this.tableHeight = 300;
        _this.data = [];
        _this.data_search = [];
        _this.frontData = [];
        _this.formData = {
            order_id: '',
            order_name: '',
            es_time: weekDefaultDate().Tomorrow.format('yyyy-MM-dd'),
            ee_time: weekDefaultDate().End.format('yyyy-MM-dd'),
            business_info: [],
            business_info_name: '',
            supplier_to_business_ids: [],
            group_ids: [],
            order_icomment: '',
            order_arriveddate: '',
            purchase_order_order_ids: [],
            is_batch_update_delivery_uprice: 1
        };
        _this.handleStatus = EHandleStatus.Add;
        _this.orderid = '';
        _this.pageuse = '';
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.categoryData = [];
        _this.goods_type_id = null;
        _this.keyword = "";
        _this.goods_ids = [];
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.created = function () {
        var _this = this;
        this.service = BusinessGoodsPriceService.getInstance();
        if (this.orderid && this.pageuse == 'copy') {
            this.handleStatus = EHandleStatus.Copy;
            this.getDetailByCopy();
        }
        else if (this.orderid) {
            this.handleStatus = EHandleStatus.Edit;
            this.getDetail();
        }
        this.getCategory();
        this.getAuth('6007').then(function (pageAuth) {
            _this.PageAuth = pageAuth.Auth;
            console.log('pageAuth', pageAuth, _this.PageAuth);
        });
    };
    default_1.prototype.getCategory = function () {
        var _this = this;
        this.service.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 340;
        }, 300);
    };
    default_1.prototype.changeMoney = function (row) {
        row.goods_price = this.digitRules(row.goods_price, 2);
    };
    default_1.prototype.digitRules = function (value, amount_digit) {
        if (value.toString().indexOf(".") > 0) {
            if (value.toString().length - value.toString().indexOf(".") > (amount_digit ? (Number(amount_digit) + 1) : 0)) {
                return value.substring(0, value.indexOf(".") + Number(amount_digit) + 1);
            }
            else {
                return value;
            }
        }
        else {
            return value;
        }
    };
    default_1.prototype.myFixed = function (num, digit) {
        return BigNumber(num).toFixed(digit);
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid
        };
        this.service.getDetail(params).then(function (res) {
            var data = res.data.data;
            _this.is_erp = data.is_erp;
            _this.service.getClientsByGroupTree({ is_have_empty_group: 1, is_have_shop: 1 }).then(function (res2) {
                var cgTree = res2.data.data || [];
                var supplier_to_business_ids = data.supplier_to_business_ids || [];
                var shop_supplier_to_business_ids = (data.shop_ids || []).map(function (shop) {
                    return shop.shop_id + '_' + shop.supplier_to_business_id + '_' + shop.business_id;
                });
                var tmp_supplier_to_business_ids = supplier_to_business_ids.concat(shop_supplier_to_business_ids);
                var res3 = tidyDataBusinessInfo(cgTree, tmp_supplier_to_business_ids, data.group_ids || [], data.shop_ids || [], data.business_ids || []);
                data.business_info = res3.business_info;
                data.business_info_name = res3.business_info_name;
                data.supplier_to_business_ids = res3.supplier_to_business_ids;
                var orderList = data.purchase_order_orders || [];
                if (orderList.length) {
                    data.purchase_order_order_ids = orderList.map(function (item) { return item.other_id; });
                }
                var goods_ids = (data.details || []).map(function (good) {
                    return good.goods_id;
                });
                _this.goods_ids = goods_ids || [];
                _this.formData = Object.assign({}, _this.formData, data);
                _this.data = data.details || [];
                _this.data_search = _this.data;
                _this.getGoodList();
                loadingInstance.close();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getDetailByCopy = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid,
            is_copy: 1
        };
        this.service.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.service.getClientsByGroupTree({ is_have_empty_group: 1, is_have_shop: 1 }).then(function (res2) {
                var cgTree = res2.data.data || [];
                var supplier_to_business_ids = data.supplier_to_business_ids || [];
                var shop_supplier_to_business_ids = (data.shop_ids || []).map(function (shop) {
                    return shop.shop_id + '_' + shop.supplier_to_business_id + '_' + shop.business_id;
                });
                var tmp_supplier_to_business_ids = supplier_to_business_ids.concat(shop_supplier_to_business_ids);
                var res3 = tidyDataBusinessInfo(cgTree, tmp_supplier_to_business_ids, data.group_ids || [], data.shop_ids || [], data.business_ids || []);
                data.business_info = res3.business_info;
                data.business_info_name = res3.business_info_name;
                _this.formData = Object.assign({}, _this.formData, {
                    supplier_to_business_ids: data.supplier_to_business_ids,
                    group_ids: data.group_ids,
                    business_info: data.business_info,
                    business_info_name: data.business_info_name
                });
                var filteredDetails = (data.details || []).filter(function (item) {
                    return item.goods_status !== 0;
                });
                _this.data = filteredDetails;
                _this.data_search = _this.data;
                _this.getGoodList();
                _this.orderid = '';
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.save = function (saveType) {
        var _this = this;
        if (saveType === void 0) { saveType = 0; }
        if (!this.checkSave()) {
            return;
        }
        var formData = this.formData;
        var params = {
            audit: saveType,
            order_name: formData.order_name,
            es_time: formData.es_time,
            ee_time: formData.ee_time,
            is_batch_update_delivery_uprice: formData.is_batch_update_delivery_uprice,
            order_icomment: formData.order_icomment,
            order_arriveddate: formData.order_arriveddate,
            purchase_order_order_ids: formData.purchase_order_order_ids,
            business_info: JSON.stringify(formData.business_info),
            data: JSON.stringify(this.data.map(function (v) {
                return {
                    goods_id: v.goods_id,
                    goods_format_id: v.goods_format_id,
                    goods_price: v.goods_price,
                    tax_rate: v.tax_rate
                };
            }))
        };
        params.is_batch_update_delivery_uprice = formData.purchase_order_order_ids.length ? formData.is_batch_update_delivery_uprice : 0;
        var saveSvc = this.service.addSave;
        if (this.orderid) {
            params = Object.assign({}, params, { order_id: this.orderid });
            saveSvc = this.service.editSave;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        saveSvc(params).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            setTimeout(function () {
                GLOBAL_VUE.$emit("closeTab", _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
            }, 500);
            if (_this.handleStatus === EHandleStatus.Copy) {
                window._czc.push(["_trackEvent", '复制销售价格', '保存', '保存']);
            }
            else if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(["_trackEvent", '修改销售价格', '保存', '保存']);
            }
            else {
                window._czc.push(["_trackEvent", '添加销售价格', '保存', '保存']);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    default_1.prototype.validateForm = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.$validator.validateScopes();
        });
    };
    default_1.prototype.checkSave = function () {
        this.$refs.addheader.validateForm();
        this.validateForm();
        var flag = true, msg = [];
        if (!this.formData.order_name) {
            this.$message.warning("价格单名称不可为空");
            return false;
        }
        if (!this.formData.supplier_to_business_ids.length && !this.formData.group_ids.length) {
            this.$message.warning("应用门店不可为空");
            return false;
        }
        this.data.map(function (row) {
            if (!row.goods_price && row.goods_price !== 0) {
                flag = false;
                msg.push('销售价不可为空');
            }
            if (!row.tax_rate && row.tax_rate !== 0) {
                flag = false;
                msg.push('销售税率不可为空');
            }
        });
        if (!flag) {
            this.$message.warning(msg[0]);
            return false;
        }
        return true;
    };
    default_1.prototype.handleGoodsFieldDiffOrderField = function (res, type) {
        if (Array.isArray(res) && res.length) {
            res.forEach(function (item) {
                if (!item.business_goods_id) {
                    item.business_goods_id = 0;
                }
            });
        }
        return res;
    };
    default_1.prototype.toAddGood = function () {
        var _this = this;
        var dialog = this.$dialog(AddGoods, {
            data: {
                addedDatas: this.data,
                tabTableComponent: 'sale-bind-goods-tab-table',
                showSelected: true,
                dimension: 2,
                dimension_lock: true,
            }
        }, {
            title: "添加货品",
            width: 900,
            height: 550
        });
        dialog.instance.$on("save:ok", function (res) {
            res = _this.handleGoodsFieldDiffOrderField(res);
            _this.data = res;
            console.log('---submit', res);
            _this.selections = [];
            if (_this.handleStatus === EHandleStatus.Copy) {
                window._czc.push(["_trackEvent", '复制销售价格', '添加货品', '添加货品']);
            }
            else if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(["_trackEvent", '修改销售价格', '添加货品', '添加货品']);
            }
            else {
                window._czc.push(["_trackEvent", '添加销售价格', '添加货品', '添加货品']);
            }
            _this.search();
            _this.getGoodList();
            dialog.instance.close();
        });
    };
    default_1.prototype.handleAdd = function (goodsList) {
        var _this = this;
        console.log('------handleAdd', goodsList);
        goodsList.forEach(function (good) {
            var filter = function (item) {
                return item.goods_id === good.goods_id && item.business_goods_id === good.business_goods_id && item.goods_format_id === good.goods_format_id;
            };
            if (!_this.data.some(function (item) { return filter(item); })) {
                good.tax_rate = numMulti(Number(good.tax_rate), 100);
                _this.data.push(good);
            }
        });
        this.search();
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请选择货品");
            return;
        }
        this.$confirm("请确认是否删除该货品", '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHandleStatus.Copy) {
                window._czc.push(["_trackEvent", '复制销售价格', '添加货品', '添加货品']);
            }
            else if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(["_trackEvent", '修改销售价格', '删除货品', '删除货品']);
            }
            else {
                window._czc.push(["_trackEvent", '添加销售价格', '删除货品', '删除货品']);
            }
            _this.search();
            _this.getGoodList();
        }, function (err) { });
    };
    default_1.prototype.batchUpdateGoodsPrice = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请先选择货品");
            return;
        }
        var dialog = this.$dialog(UpdateGoodsPrice, {
            data: {
                addedDatas: this.data,
                tabTableComponent: 'license-bind-goods-tab-table',
                showSelected: true,
                dimension: 2,
                dimension_lock: true,
                is_erp: this.is_erp,
            }
        }, {
            title: [
                '批量改价',
                'border-bottom: 0px;'
            ],
            width: 450,
            height: 250
        });
        dialog.instance.$on("save:ok", function (priceRes) {
            console.log('---批量改价', priceRes, _this.data);
            console.log('---priceRes.type', priceRes.type);
            if (priceRes.type == 1 || priceRes.type == 2) {
                var param = {
                    'goods_format_ids': _this.selections.map(function (v) { return v.goods_format_id; }).join(','),
                    'business_goods_ids': _this.selections.map(function (v) { return v.business_goods_id; }).join(','),
                    'price_base': priceRes.price_base,
                };
                _this.service.getPriceBase(param).then(function (res) {
                    if (res.data.success) {
                        if (res.data.data.length) {
                            var price_base_data_1 = {};
                            res.data.data.forEach(function (item) {
                                price_base_data_1[item.goods_id_unique_key] = item;
                            });
                            console.log('---success', _this.selections);
                            _this.selections.forEach(function (item) {
                                var index = _this.data.indexOf(item);
                                var goods_id_unique_key = _this.data[index]['business_goods_id'] + '_' + _this.data[index]['goods_id'] + '_' + _this.data[index]['goods_format_id'];
                                var goods_price = _this.data[index]['goods_price'];
                                if (price_base_data_1.hasOwnProperty(goods_id_unique_key)) {
                                    goods_price = Number(price_base_data_1[goods_id_unique_key]['goods_price']);
                                    console.log(11113, goods_price, price_base_data_1[goods_id_unique_key]);
                                    if (priceRes.type == 1) {
                                        goods_price = goods_price + goods_price * (Number(priceRes.ratio) / 100);
                                    }
                                    else if (priceRes.type == 2) {
                                        goods_price = goods_price + Number(priceRes.added_money);
                                    }
                                    if (goods_price < 0) {
                                        goods_price = 0;
                                    }
                                }
                                console.log(222, goods_price);
                                _this.data[index]['goods_price'] = _this.myFixed(goods_price.toString(), 2);
                                ;
                                console.log(11112, _this.data[index]['goods_price']);
                            });
                        }
                        _this.selections = [];
                        _this.search();
                        _this.getGoodList();
                        dialog.instance.close();
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                }, function (err) {
                    _this.$message.error(err.message || err.msg);
                }).catch(function (err) {
                    _this.$message.error(err.message);
                });
            }
            else if (priceRes.type == 3) {
                _this.selections.forEach(function (item) {
                    var index = _this.data.indexOf(item);
                    var goods_price = Number(priceRes.price);
                    if (goods_price < 0) {
                        goods_price = 0;
                    }
                    _this.data[index]['goods_price'] = _this.digitRules(goods_price.toString(), 2);
                    ;
                });
                _this.search();
                _this.getGoodList();
                dialog.instance.close();
            }
        });
    };
    default_1.prototype.pageChange = function (pager) {
        this.getGoodList(pager);
        this.$refs.table.bodyWrapper.scrollTop = 0;
    };
    default_1.prototype.getGoodList = function (pager) {
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var frontData = [];
        var startIndex = pager.start;
        var endIndex = pager.start + pager.limit - 1;
        for (var i = startIndex; i <= endIndex; i++) {
            if (!this.data_search[i]) {
                break;
            }
            frontData.push(this.data_search[i]);
        }
        this.frontData = frontData;
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    default_1.prototype.search = function () {
        var _this = this;
        this.$refs.pagination.clear();
        this.data_search = this.data;
        var child_type_ids = [];
        if (this.goods_type_id) {
            child_type_ids = this.getGoodsTypeIds(this.categoryData[0]);
        }
        this.data_search = this.data_search.filter(function (item) {
            var result = true;
            console.log(1112, _this.keyword, item);
            if (_this.keyword && _this.goods_type_id) {
                result = (item.goods_name.includes(_this.keyword)
                    || item.goods_format_code.includes(_this.keyword)
                    || item.bar_code.includes(_this.keyword)
                    || item.goods_initial == _this.keyword.toUpperCase())
                    && child_type_ids.includes(item.goods_type_id);
            }
            else if (_this.keyword) {
                result = item.goods_name.includes(_this.keyword) || item.goods_format_code.includes(_this.keyword) || item.bar_code.includes(_this.keyword) || item.goods_initial == _this.keyword.toUpperCase();
            }
            else if (_this.goods_type_id) {
                result = child_type_ids.includes(item.goods_type_id);
            }
            return result;
        });
        this.getGoodList();
        this.$refs.table.bodyWrapper.scrollTop = 0;
    };
    default_1.prototype.getGoodsTypeIds = function (item) {
        var _this = this;
        console.log('type ' + item.goods_type_id);
        var goods_type_ids = undefined;
        if (item.goods_type_id == this.goods_type_id) {
            goods_type_ids = [];
            goods_type_ids.push(item.goods_type_id);
            goods_type_ids = this.getGoodsTypeChildIds(item, goods_type_ids);
        }
        else {
            var flag_1 = false;
            if (item.children == undefined) {
                return goods_type_ids;
            }
            item.children.map(function (val) {
                if (flag_1) {
                    return;
                }
                var ids = _this.getGoodsTypeIds(val);
                if (ids !== undefined) {
                    goods_type_ids = ids;
                    flag_1 = true;
                }
            });
        }
        return goods_type_ids;
    };
    default_1.prototype.getGoodsTypeChildIds = function (item, goods_type_ids) {
        var _this = this;
        console.log('child ' + item.goods_type_id);
        if (item.children == undefined) {
            return goods_type_ids;
        }
        item.children.map(function (val) {
            goods_type_ids.push(val.goods_type_id);
            goods_type_ids = _this.getGoodsTypeChildIds(val, goods_type_ids);
        });
        return goods_type_ids;
    };
    default_1.prototype.reset = function () {
        this.$refs.pagination.clear();
        this.data_search = this.data;
        this.getGoodList();
        this.goods_type_id = null;
        this.keyword = "";
        this.$refs.table.bodyWrapper.scrollTop = 0;
    };
    default_1 = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
